import React from 'react';
import { Lightbulb, Search, Sparkles } from 'lucide-react';
import Button from '../ui/Button';
import { useBetaProgram } from '../../beta/hooks';
import { stripBetaPrefix } from '../../beta/routing';
import { findSeoGuidanceForPath } from '../../beta/seoGuidance';
import { useLocation } from 'react-router-dom';

const SeoHighlightsPanel = () => {
  const location = useLocation();
  const { isBetaMode, program } = useBetaProgram();

  if (!isBetaMode || !program?.features?.seoHighlights) {
    return null;
  }

  const sitePath = stripBetaPrefix(location.pathname);
  const guidance = findSeoGuidanceForPath(sitePath);

  return (
    <div className="bg-emerald-50 border-y border-emerald-200">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
          <div>
            <p className="text-sm font-semibold uppercase tracking-wide text-emerald-800 flex items-center gap-2">
              <Sparkles size={15} />
              SEO Beta Highlight
            </p>
            <h3 className="text-lg font-semibold text-emerald-900 mt-1">
              {guidance.pageLabel} - integrated SEO suggestions for this route
            </h3>
          </div>

          <Button href="/seo-lab" variant="outlined" className="border-emerald-700 text-emerald-700 hover:bg-emerald-700 hover:text-white">
            Open SEO Lab
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mt-4">
          <article className="bg-white border border-emerald-200 rounded-lg p-3">
            <p className="text-xs text-gray-500 uppercase tracking-wide">Primary Keyword</p>
            <p className="text-sm font-semibold text-gray-900 mt-1 flex items-center gap-2">
              <Search size={14} className="text-emerald-700" />
              {guidance.primaryKeyword}
            </p>
          </article>

          <article className="bg-white border border-emerald-200 rounded-lg p-3">
            <p className="text-xs text-gray-500 uppercase tracking-wide">Title Tag Example</p>
            <p className="text-sm text-gray-900 mt-1">{guidance.titleTagExample}</p>
          </article>

          <article className="bg-white border border-emerald-200 rounded-lg p-3">
            <p className="text-xs text-gray-500 uppercase tracking-wide">Schema</p>
            <p className="text-sm text-gray-900 mt-1">{guidance.schemaType}</p>
            <p className="text-xs text-gray-500 mt-2">Internal links: {guidance.internalLinks.join(', ')}</p>
          </article>

          <article className="bg-white border border-emerald-200 rounded-lg p-3">
            <p className="text-xs text-gray-500 uppercase tracking-wide">Content Angle</p>
            <p className="text-sm text-gray-900 mt-1 flex items-start gap-2">
              <Lightbulb size={14} className="text-emerald-700 mt-0.5" />
              {guidance.contentAngle}
            </p>
          </article>
        </div>
      </div>
    </div>
  );
};

export default SeoHighlightsPanel;
